import React, { useEffect } from 'react'
import { components, useTranslation } from 'cng-web-lib'
import { Dialog, DialogContent, DialogTitle, DialogActions, Typography, Divider } from '@material-ui/core'
import { useForm, FormProvider } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import Namespace from 'src/constants/locale/Namespace'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'
import ContainerDetailsFormProperties from './ContainerDetailsFormProperties'
import ContainerDetailsMakeValidationSchema from './ContainerDetailsMakeValidationSchema'

const {
  button: { CngButton }
} = components

function ContainerDetailsDialog(props) {
  const { containerDetails, isView, onAddContainerDetails, onEditContainerDetails, open, onClose, showNotification } = props
  const { translate } = useTranslation(Namespace.UAE_MPCI)
  const title = translate(Namespace.UAE_MPCI, UaeMpciKeys.ContainerDetails.TITLE)
  const saveButton = translate(Namespace.UAE_MPCI, UaeMpciKeys.SAVE_BUTTON)

  const validationSchema = ContainerDetailsMakeValidationSchema(translate)

  const methods = useForm({
    defaultValues: ContainerDetailsFormProperties.formikProps.initialValues,
    resolver: yupResolver(validationSchema)
  })

  const { handleSubmit, reset } = methods

  useEffect(() => {
    if (open) {
      if (containerDetails) {
        reset(containerDetails)
      } else {
        reset(ContainerDetailsFormProperties.formikProps.initialValues)
      }
    }
  }, [open, containerDetails])

  function onSubmit(data) {
    if (containerDetails) {
      onEditContainerDetails(data)
    } else {
      onAddContainerDetails(data)
    }
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        <Typography variant="h5"><strong>{title}</strong></Typography>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <FormProvider {...methods}>
          <form>
            <ContainerDetailsFormProperties.Fields disabled={isView} />
          </form>
        </FormProvider>
      </DialogContent>
      <DialogActions>
        <CngButton color="secondary" onClick={onClose} size="medium">Cancel</CngButton>
        {!isView && (
          <CngButton color="primary" onClick={handleSubmit(onSubmit)} size="medium">
            {containerDetails ? 'Update' : saveButton}
          </CngButton>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default ContainerDetailsDialog
